import { render, staticRenderFns } from "./Player2.vue?vue&type=template&id=31e5d02f&scoped=true&"
import script from "./Player2.vue?vue&type=script&lang=js&"
export * from "./Player2.vue?vue&type=script&lang=js&"
import style0 from "./Player2.vue?vue&type=style&index=0&id=31e5d02f&prod&lang=css&"
import style1 from "./Player2.vue?vue&type=style&index=1&id=31e5d02f&prod&lang=scss&scoped=true&"
import style2 from "./Player2.vue?vue&type=style&index=2&id=31e5d02f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5d02f",
  null
  
)

export default component.exports